// extracted by mini-css-extract-plugin
module.exports = {"section":"Page__section--3YChj"};